import {useState, useEffect} from "react";
import {  getLLMConfigurationsList, SaveLLMConfig, UpdateLLMConfig, DeleteLLMConfig } from './../../utils/APIClient'
import { useForm } from "react-hook-form";
import {triggerAlert, ConfirmationAlert} from './../../utils/commonFunctions'
import Modal from 'react-bootstrap/Modal';
import { createThemeData, customStyles } from './../../utils/Constants'
import DataTable, { createTheme } from "react-data-table-component";
const LLMConfigs = () => {
    document.title = "Callingo | LLM Configurations"
    const { register, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm();
    const [folderList, setfolderList] = useState([])
    const [hide, sethide] = useState(false)
    const [editid, seteditid] = useState()
    const [disabled, setdisabled] = useState(false)
    const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)
    createTheme('solarized', createThemeData, 'dark');
    const columns = [
        {
            name: "Sr.No",
            selector: (row, i) => i,
            cell: (row, i) => i + 1,
        },
        {
            name: "LLM Provider",
            selector: (row) => row.llm_provider,
            cell: row => row.llm_provider,
        },
        {
            name: "LLM Model",
            selector: (row) => row.folder_name,
            cell: row => row.folder_name,
        },
        

        {
            name: "Action",

            cell: row => (
                <div className="col-auto" id="tooltip-container9">
                    <button className="btn btn-link text-warning btn-lg p-0 me-1" onClick={() => { sethide(true); onloadeddata(row) }}  >
                        <i className="ri-edit-box-line  "></i>   </button>
                    <button className="btn btn-link text-danger btn-lg p-0" onClick={() => { ConfirmationAlert("Do you want to delete LLM Configurations from database", "Delete", () => DeleteFolder(row)); }}>
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            ),
        },

    ]
    const getLLMConfigurations = async () => {
        setdisabled(true)
        try{
            let folders = await getLLMConfigurationsList();
            if (folders.data) {
                setdisabled(false)
                if (folders.data) {
                    setfolderList([...folders.data])
                }
            }
        } catch (error) {
            setdisabled(false)
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);   
        }
    }
    const submitFolder = async (data) => {
        if(editid){
            try {
                data.folder_id  = editid
                const response = await UpdateLLMConfig(data);
                const respdata = response.data;
                if (response.status === 200) {
                    triggerAlert('success', '', `LLM Configurations updated successfully` || 'Something went wrong');
                    getLLMConfigurations();
                    sethide(false)
                }
            } catch (error) {
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        }else{
            try {
                const response = await SaveLLMConfig(data);
                const respdata = response.data;
                if (response.status === 201) {
                    triggerAlert('success', '', `LLM Configurations created successfully` || 'Something went wrong');
                    getLLMConfigurations();
                    sethide(false)
                }
            } catch (error) {
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        }
        
    }
    const onloadeddata = (data) => {
        setValue("llm_provider", data.llm_provider)
        setValue("llm_model", data.llm_model)
        seteditid(data.id)
    }
    const DeleteFolder = async (data) => {
        try {
            const response = await  DeleteLLMConfig(data.id);
            const respdata = response.data;
            if (response.status === 204) {
                triggerAlert('success', '', `LLM Configurations deleted successfully` || 'Something went wrong');
                getLLMConfigurations();
            }
        } catch (error) {
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
    const handlePageChange = page => {
        getLLMConfigurations(page_size, page )
        setpage_number(page);
    };

    const handlePerRowsChange = async (newPerPage, page = page_number) => {
        getLLMConfigurations(newPerPage, page )
        setpage_size(newPerPage);
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    useEffect(() => {
        getLLMConfigurations();
    }, [])
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title lh-1 mb-3">LLM Configurations</h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="page-title-box mb-3">
                    <button className="btn btn-success  mt-0 page-title-right" onClick={()=> {sethide(true); reset(); seteditid()}} ><i className=" ri-user-add-line"></i> Create LLM Configurations</button>
                    <div className="page-title-left">
                        <div className="app-search">
                            <form>
                                <div className="mb-2 position-relative">
                                    <input type="text" className="form-control border border-dark border-opacity-10" placeholder="Search files..." />
                                    <span className="ri-search-line search-icon"></span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card  ">
                        <div className="card-body">

                            {disabled ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> :

                    <DataTable
                        columns={columns}
                        fixedHeader

                        persistTableHead
                        data={folderList}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPages}
                        paginationDefaultPage={page_number}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationPerPage={page_size}
                         
                        theme="solarized"
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    /> }
                            
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={hide} onHide={() => sethide(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create LLM Configurations</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(submitFolder)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="llm_provider" className="form-label">LLM Provider</label>
                            <input
                                type="text"

                                id="llm_provider"
                                name="llm_provider"
                                {...register("llm_provider", { required: "LLM Provider is required" })}
                                className="form-control"
                                placeholder="Enter your LLM Provider"
                                autoComplete='off'
                            />
                            {errors.llm_provider && <small className="text-danger d-block mb-2">{errors.llm_provider.message}</small>}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="llm_model" className="form-label">LLM Model</label>
                            <input
                                type="text"

                                id="llm_model"
                                name="llm_model"
                                {...register("llm_model", { required: "LLM Model is required" })}
                                className="form-control"
                                placeholder="Enter your LLM Model"
                                autoComplete='off'
                            />
                            {errors.llm_model && <small className="text-danger d-block mb-2">{errors.llm_model.message}</small>}
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-warning  rounded px-3" onClick={() => sethide(false)}>Cancel</button>
                        <button type="submit" className="btn btn-success  rounded px-3">Save</button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>

    )
}

export default LLMConfigs;